import {setup} from '../../../sourcepointConsent';

setup(window.pageflow.consent);
